function mediaPlayer (data,store,ref,useDraggable) {
  console.log("Media Player Got : ", data);
  if(data.Event.Mode == "MEETUS" || data.Event.Mode == "MEDIA") {
    if(data.Event.ClientID) {
      let viewPorts = window.devStore.getViewportsByClient(data.Event.ClientID);
      console.log("Mp Check viewPorts : ", viewPorts);
      let mediaPlayerFlag =  false;
      if(viewPorts && viewPorts.length > 0) {
          viewPorts.forEach((viewPort) => {
            if(viewPort.ClientPath.includes("MediaPlayer")) {
              mediaPlayerFlag = true;
            } else {
              if(mediaPlayerFlag == false) {
                //let client = JSON.parse(JSON.stringify(data.Client));
                let client = window.botStore.getClientByID(data.Event.ClientID);
                client.clientID = client.ClientID;
                //let viewPortId = window.LivingScript_0070.guid.generateSync();
                let parentIndex = store.getMeetingIndex(client.RootMeeting);
                let localIndex = store.getMeetingIndex(client.Meeting);
        
                let path = '';
                if(parentIndex == localIndex) {
                  path = path + client.RootMeeting;
                } else {
                  path = path + client.RootMeeting + '/' + client.Meeting;
                }
                path = path + '/MediaPlayer';
                let menuObj = {
                  ParentIndex : parentIndex,
                  LocalIndex : localIndex,
                  PrettyURL : null,
                  Path : path,
                  LeftRole : client.ClientLeftRole,
                  RightRole : client.ClientRightRole,
                  LeftID : client.ClientLeft,
                  RightID : client.ClientRight,
                  LeftDN : client.ClientLeftDN,
                  RightDN : 'MediaPlayer',
                  DisplayStatus : null,
                  ClientRowID : client.Client
                };
                store.addRootMenu(menuObj);
                
                //window.BotServices.PullRootMenu(menuObj);
                //let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-mediaplayer',"URL":"/CommunicationClient/wcdist/src/CommMediaPlayer.js"};
                //let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/GraphMediaPlayer/index.html?clientID="+client.Client};
                //let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayer/index.html?clientID="+client.Client};
                let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV2/index.html?clientID="+client.Client};
                window.BotServices.openChildPanel({ClientID : client.Client, DisplayName : 'MediaPlayer', Termination : terminationUrl}, ()=>{});
        
          /*      let newViewport = {
                  viewportID : viewPortId,
                  ClientID : client.Client,
                  MeetingPath : '/',
                  ClientPath : client.Client+'/MediaPlayer',
                  TopLeftX : "0px",
                  TopRightY : "0px",
                  Width:"100%",
                  Height:"100%",
                  PanelTitle: parentIndex+"/"+localIndex+" "+client.ClientLeftDN+'/'+client.ClientRightDN+'/MediaPlayer',
                  DisplayState: 'Media'
                }
                //store.addViewPort(newViewport);
                window.BotServices.PullViewPort(newViewport, menuObj);
        
                if(newViewport.DisplayState =='Media') {
                  //store.addTerminationPoint({viewportID:viewPortId, terminationID : window.LivingScript_0070.guid.generateSync(), MediaType : 'Iframe',URL:'/DeepLander-0086/Tests/mediaPlayerApp/showmedia.html',DisplayState: 'Media'});
                  //store.addTerminationPoint({viewportID:viewPortId, terminationID : window.LivingScript_0070.guid.generateSync(), MediaType : 'WebComponent',URL:'/CommunicationClient/wcdist/src/CommMediaPlayer.js', Template : 'oxygen-mediaplayer', DisplayState: 'Media'});
                  let newTermination = {
                    viewportID:viewPortId,
                    terminationID : window.LivingScript_0070.guid.generateSync(),
                    MediaType : 'WebComponent',
                    URL:'/CommunicationClient/wcdist/src/CommMediaPlayer.js',
                    Template : 'oxygen-mediaplayer',
                    DisplayState: 'Media'
                  }
                  window.BotServices.PullTermination(newTermination, menuObj);
                  store.setLanding(false);
                }*/
              }
            }
          })
      } else {
        if(mediaPlayerFlag == false) {
          //let client = JSON.parse(JSON.stringify(data.Client));
          let client = window.botStore.getClientByID(data.Event.ClientID);
          client.clientID = client.ClientID;
          //let viewPortId = window.LivingScript_0070.guid.generateSync();
          let parentIndex = store.getMeetingIndex(client.RootMeeting);
          let localIndex = store.getMeetingIndex(client.Meeting);
  
          let path = '';
          if(parentIndex == localIndex) {
            path = path + client.RootMeeting;
          } else {
            path = path + client.RootMeeting + '/' + client.Meeting;
          }
          path = path + '/MediaPlayer';
          let menuObj = {
            ParentIndex : parentIndex,
            LocalIndex : localIndex,
            PrettyURL : null,
            Path : path,
            LeftRole : client.ClientLeftRole,
            RightRole : client.ClientRightRole,
            LeftID : client.ClientLeft,
            RightID : client.ClientRight,
            LeftDN : client.ClientLeftDN,
            RightDN : 'MediaPlayer',
            DisplayStatus : null,
            ClientRowID : client.Client
          };
          store.addRootMenu(menuObj);
          
          //window.BotServices.PullRootMenu(menuObj);
          //let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-mediaplayer',"URL":"/CommunicationClient/wcdist/src/CommMediaPlayer.js"};
          //let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/GraphMediaPlayer/index.html?clientID="+client.Client};
          //let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayer/index.html?clientID="+client.Client};
          let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV2/index.html?clientID="+client.Client};
          window.BotServices.openChildPanel({ClientID : client.Client, DisplayName : 'MediaPlayer', Termination : terminationUrl}, ()=>{});
        }
      }
    }
  }
  /* else if(data.Event.Mode == "MEDIA") {
    if(data.Event.ClientID && store.isMediaPlayer(data.Event.ClientID) === undefined) {
        console.log("Open New Media Player");
        let client = window.botStore.getClientByID(data.Event.ClientID);
        console.log("Got client by client id : ",client);
        client.clientID = data.Event.ClientID;
        let viewPortId = window.LivingScript_0070.guid.generateSync();
        let parentIndex = store.getMeetingIndex(client.RootMeeting);
        let localIndex = store.getMeetingIndex(client.Meeting);

        let path = '';
        if(parentIndex == localIndex) {
          path = path + client.RootMeeting;
        } else {
          path = path + client.RootMeeting + '/' + client.Meeting;
        }
        path = path + '/MediaPlayer';
        let menuObj = {
          ParentIndex : parentIndex,
          LocalIndex : localIndex,
          PrettyURL : null,
          Path : path,
          LeftRole : client.ClientLeftRole,
          RightRole : client.ClientRightRole,
          LeftID : client.ClientLeft,
          RightID : client.ClientRight,
          LeftDN : client.ClientLeftDN,
          RightDN : 'MediaPlayer',
          DisplayStatus : null,
          ClientRowID : client.Client,
          ViewPortID : viewPortId,
        };
        store.addRootMenu(menuObj);
        let newViewport = {
          viewportID : viewPortId,
          ClientID : client.Client,
          MeetingPath : '/',
          ClientPath : client.Client+'/MediaPlayer',
          TopLeftX : "0px",
          TopRightY : "0px",
          Width:"100%",
          Height:"100%",
          PanelTitle: parentIndex+"/"+localIndex+" "+client.ClientLeftDN+'/'+client.ClientRightDN+'/MediaPlayer',
          DisplayState: 'Media'
        }
        //store.addViewPort(newViewport);
        window.BotServices.PullViewPort(newViewport, menuObj);

        if(newViewport.DisplayState =='Media') {
          //store.addTerminationPoint({viewportID:viewPortId, terminationID : window.LivingScript_0070.guid.generateSync(), MediaType : 'Iframe',URL:'/DeepLander-0086/Tests/mediaPlayerApp/showmedia.html',DisplayState: 'Media'});
          //store.addTerminationPoint({viewportID:viewPortId, terminationID : window.LivingScript_0070.guid.generateSync(), MediaType : 'WebComponent',URL:'/CommunicationClient/wcdist/src/CommMediaPlayer.js', Template : 'oxygen-mediaplayer', DisplayState: 'Media'});
          let newTermination = {
            viewportID:viewPortId,
            terminationID : window.LivingScript_0070.guid.generateSync(),
            MediaType : 'WebComponent',
            URL:'/CommunicationClient/wcdist/src/CommMediaPlayer.js',
            Template : 'oxygen-mediaplayer',
            DisplayState: 'Media'
          }
              window.BotServices.PullTermination(newTermination, menuObj);
          store.setLanding(false);
        }
    }
  }*/
}

export {
  mediaPlayer
}
